import { useApolloClient } from 'react-apollo';
import React, { useContext, useEffect } from 'react';
import AuthContext from './AuthContext';
import { withCookies } from 'react-cookie';
import { useLocation, useHistory } from 'react-router';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import { useShopConfig } from '../../hooks/useShopConfig';
import { trackUserEvent } from '../../analytics/tracking';
import { useTracker } from '../../analytics/Analytics';
import { useQuery } from '@apollo/react-hooks';
import googleUserIdQuery from './googleUserIdQuery.gql';
const AuthProvider = function AuthProvider(props) {
    var _a, _b;
    const token = (_b = (_a = props === null || props === void 0 ? void 0 : props.cookies) === null || _a === void 0 ? void 0 : _a.cookies) === null || _b === void 0 ? void 0 : _b.authToken;
    const [loggedIn, setLoggedIn] = React.useState(!!token);
    const client = useApolloClient();
    const { selectedChannel } = useContext(ChannelContext);
    const { pathsWithNoAuthRequired, loginPath } = useShopConfig();
    const location = useLocation();
    const history = useHistory();
    const track = useTracker();
    const userGoogleIdResult = useQuery(googleUserIdQuery, {
        skip: !loggedIn
    });
    // Tracking user by Google id
    useEffect(() => {
        var _a, _b;
        if (!userGoogleIdResult.data)
            return;
        const googleUserId = (_b = (_a = userGoogleIdResult === null || userGoogleIdResult === void 0 ? void 0 : userGoogleIdResult.data) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.googleUserId;
        if (googleUserId)
            track(trackUserEvent({ userId: googleUserId }));
    }, [userGoogleIdResult, track]);
    // Redirec to login on unauthorised routes
    useEffect(() => {
        if (!selectedChannel.requiresAuth)
            return;
        if (loggedIn)
            return;
        const matches = pathsWithNoAuthRequired.filter((route) => location.pathname.startsWith(route)).length > 0;
        if (!matches) {
            history.replace(loginPath);
        }
    });
    // Keeping tabs in sync for logging in and out
    useLocalStorageLoggedIn(setLoggedIn);
    const value = React.useMemo(() => ({
        requiresAuth: selectedChannel.requiresAuth,
        loggedIn,
        updateLoggedIn: (loggedIn, token) => {
            if (loggedIn) {
                if (!token) {
                    throw new Error('No log in token provided');
                }
                props.auth.setAuthToken(token);
                localStorage.setItem('loggedIn', '1');
            }
            else {
                props.auth.clearAuthToken();
                localStorage.removeItem('loggedIn');
            }
            client
                .resetStore()
                .then(() => setLoggedIn(loggedIn))
                .catch(() => setLoggedIn(loggedIn));
        }
    }), [client, loggedIn, props.auth, selectedChannel.requiresAuth]);
    return React.createElement(AuthContext.Provider, Object.assign({ value: value }, props));
};
const useLocalStorageLoggedIn = (setLoggedIn) => {
    useEffect(() => {
        const listener = (e) => {
            const localStorageLoggedIn = localStorage.getItem('loggedIn');
            if (e.storageArea === localStorage && e.key === 'loggedIn') {
                setLoggedIn(!!localStorageLoggedIn);
            }
        };
        window.addEventListener('storage', listener);
        return () => {
            window.removeEventListener('storage', listener);
        };
    });
};
export default withCookies(AuthProvider);
//# sourceMappingURL=AuthProvider.js.map